export default function StepIndicator({ currentStep, totalSteps, labels = [] }) {
    return (
        <div className="aaw-si-wrap">
            {Array.from({ length: totalSteps }, (_, i) => {
                const n = i + 1;
                const state = n < currentStep ? 'done' : n === currentStep ? 'active' : 'future';

                return (
                    <div key={n} className="aaw-si-item">
                        {n < totalSteps && (
                            <div className="aaw-si-line">
                                <div className="aaw-si-line-fill" style={{ width: n < currentStep ? '100%' : '0%' }} />
                            </div>
                        )}
                        <div className={`aaw-si-dot ${state}`}>
                            {state === 'done' ? '✓' : n}
                            {state === 'active' && <span className="aaw-si-pulse" />}
                        </div>
                        {labels[i] && <span className={`aaw-si-label ${state}`}>{labels[i]}</span>}
                    </div>
                );
            })}
        </div>
    );
}
